import { TOptions } from 'i18next';
import i18n, { LocalizedTextField, i18nKeyType } from '.';

const DEFAULT_LANGUAGE = 'en';

export function keysToObject<T extends Record<string, unknown>>(
  obj: T
): { [key in keyof T]: key } {
  const newObj = {} as { [key in keyof T]: key };
  for (const key in obj) {
    newObj[key] = key;
  }
  return newObj;
}

const getLocalizedText = (
  key?: i18nKeyType | LocalizedTextField,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: TOptions<any> | string
): string | undefined => {
  if (typeof key === 'string') {
    return (i18n.exists(key as string) ? i18n.t(key, options) : key) as
      | string
      | undefined;
  } else if (typeof key === 'object') {
    // fall back to old method if key is not a string
    // examples would be server side values
    return key[DEFAULT_LANGUAGE];
  }
};

export { getLocalizedText };
